module.exports = __webpack_public_path__ + "static/media/55_000033.80064e81.jpg";